export default __webpack_public_path__ + "static/media/delihome-logo.78e2609c.svg";